import { createSelector } from '@ngrx/store';

import { getVerificationStore } from './index';

export const getCard = createSelector(getVerificationStore, ({ card }) => card);
